import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { OnboardingCommentsService } from './onboarding-comments-service/onboarding-comments.service';
import { Router } from '@angular/router';
import { HttpStatusCode } from 'axios';
import { SnackbarService } from '../../../shared/services/snackbar/snackbar.service';
import { SessionStorageService } from '../../../core/services/session-storage/session-storage.service';
import { CommentField, ViewOnboardingcomments } from './onboarding-comments-interface/view-onboardingcomments.interface';

@Component({
  selector: 'app-onboarding-comments',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  templateUrl: './onboarding-comments.html',
  styleUrl: './onboarding-comments.scss'
})
export class OnboardingComments implements OnInit {

  private fb = inject(FormBuilder);
  private snackBarService = inject(SnackbarService);
  private onboardingCommentsService = inject(OnboardingCommentsService);
  private router = inject(Router);
  private sessionStorageService = inject(SessionStorageService);

  commentFields!: CommentField[];

  viewId!: number;
  protected currentUserRole: string = "";
  data = history.state;
  viewReturnComments!: ViewOnboardingcomments[];
  status!: string;
  designation!: string;

  commentsForm!: FormGroup;

  async ngOnInit() {
    this.currentUserRole = this.sessionStorageService.getCurrentUserRole();
    if (['NEWREP', 'Introducer - Individual', 'Introducer - Corporate'].includes(this.currentUserRole)) {
      this.status = this.sessionStorageService.getCurrentApplicantStatus();
      this.designation =  this.currentUserRole;
      if (this.status == 'Candidate Update (Due Diligence)') {
        this.commentFields = [
          { key: 'onboarding', label: 'Onboarding Review Comments' },

        ];
      } else if (this.status == 'Candidate Update (Assessment)') {
        this.commentFields = [
          { key: 'DSU', label: 'DSU Review Comments' },
        ];
      }
      this.viewId = Number(this.sessionStorageService.getCurrentUserId());
    } else {
      this.viewId = this.data.id;
      this.status = this.data.status;
      this.designation = this.data.designation;
      if (this.status == 'Candidate Update (Due Diligence)') {
        this.commentFields = [
          { key: 'onboarding', label: 'Onboarding Review Comments' },

        ];
      } else if (this.status == 'Candidate Update (Assessment)') {
        this.commentFields = [
          { key: 'DSU', label: 'DSU Review Comments' },
        ];
      }
    }

    this.commentsForm = this.fb.group(
      this.commentFields.reduce((controls, field) => {
        controls[field.key] = this.fb.control({ value: '', disabled: true });
        return controls;
      }, {} as Record<string, unknown>)
    );
    this.getreturnComments();

  }

  async getreturnComments() {
    const responseData = await this.onboardingCommentsService
      .returnComments(this.viewId)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });


    if (responseData.status === HttpStatusCode.Ok) {

      this.viewReturnComments = responseData.data.responsedata;
      this.viewReturnComments.forEach((item) => {
        if (this.status == 'Candidate Update (Due Diligence)') {
          if (item.status == 'Onboarding Processing') {
            this.commentsForm.controls['onboarding'].setValue(item.remarkContent);
          }
        }
        if (this.status == 'Candidate Update (Assessment)') {
          if (['Introducer - Individual', 'Introducer - Corporate'].includes(this.designation)) {
            if (item.status == 'DSU Final Assessment') {
              this.commentsForm.controls['DSU'].setValue(item.remarkContent);
            }
          }
          else {
            if (item.status == 'DSU Initial Assessment') {
              this.commentsForm.controls['DSU'].setValue(item.remarkContent);
            }
          }
        }
      });

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }


}
